// components
import ITSImage from "@/components/ITSImage/ITSImage";
import PassportLockup from "@/components/PassportLearnMore/PassportLockup/PassportLockup";

// svgs
import PBSLogo from '@/public/svg/pbs-logotype-white--blue-fill-face.svg';

// styles
import styles from './FlowHeader.module.scss';

interface FlowHeaderProps {
  stationLogo?: string;
  stationShortCommonName?: string;
  showPassportLockup?: boolean;
}

const FlowHeader = (props: FlowHeaderProps) => {
  const { stationLogo, stationShortCommonName, showPassportLockup = false } = props;

  return (
    <header className={styles.route_header}>
      { stationLogo ?
        <ITSImage
          src={stationLogo}
          alt={stationShortCommonName || 'PBS'}
          loading="eager"
          width={170}
          className={styles.route_header__station_logo}
        />
        :
        <PBSLogo className={styles.route_header__pbs_logo} />
      }

      { showPassportLockup &&
        <PassportLockup
          shortCommonName={stationShortCommonName || 'PBS'}
          element={"h1"}
          className={styles.route_header__passport_lockup}
        />
      }
    </header>
  );
};

export default FlowHeader;
